"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOmegaEvent = useOmegaEvent;
exports.useOmegaTrack = useOmegaTrack;
var _events = require("@exc/events");
var _react = require("react");
var _metrics = _interopRequireDefault(require("./metrics"));
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

function useOmegaEvent() {
  const elementRef = (0, _react.useRef)(null);
  // works like a event handler
  function trackEvent(options) {
    const {
      element
    } = options;
    if (options.attributes) {
      options.attributes = normaliseAttributes(options.attributes);
    }
    return (0, _events.sendOmegaEvent)(element, elementRef, options);
  }
  return {
    trackEvent,
    ref: elementRef
  };
}
function normaliseAttributes(attributes) {
  const result = {};
  Object.keys(attributes).forEach(k => {
    result[k.toLowerCase()] = attributes[k];
  });
  return result;
}
function useOmegaTrack() {
  const metrics = (0, _metrics.default)('exc.pulse');
  return payload => {
    const {
      elementType,
      ...options
    } = payload;
    const {
      action,
      attributes,
      widget,
      widgetType,
      feature,
      element
    } = options;
    const finalPayload = {
      action: action || 'click',
      element,
      feature,
      type: payload.elementType,
      widget: {
        name: widget,
        type: widgetType || elementType
      },
      attributes: attributes ? normaliseAttributes(attributes) : undefined
    };
    metrics.analytics && metrics.analytics.trackEvent(finalPayload);
  };
}